import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FilterBoxMobile } from './FilterBoxMobile';   // unchanged component
import FilterOverlayMobile from "./FilterOverlayMobile";

export const DropDownFilterMobile = ({ filter }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const current = searchParams.get(filter.key)?.split(',') ?? [];

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleSave = (values) => {
        if (values.length) searchParams.set(filter.key, values.join(','));
        else searchParams.delete(filter.key);
        setSearchParams(searchParams);
    };

    return (
        <>
            <FilterBoxMobile
                title={filter.label}
                numberOfActiveFilters={current.length}
                onOpen={handleOpen}
            />

            <FilterOverlayMobile
                open={open}
                onClose={handleClose}
                filter={filter}
                params={current}
                onSave={handleSave}
            />
        </>
    );
};

export default DropDownFilterMobile;
